export const SET_SUGGESTIONS = 'mp/suggestions/SET_SUGGESTIONS';
export const CLEAR_SUGGESTIONS = 'mp/suggestions/CLEAR_SUGGESTIONS';

export const initialState = {
  suggestions: {}
};

export const suggestions = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_SUGGESTIONS:
      return {
        ...state,
        suggestions: {
          ...state.suggestions,
          ...action.payload.suggestions
        }
      };

    case CLEAR_SUGGESTIONS:
      return {
        ...state,
        suggestions: {}
      };

    default:
      return state;
  }
};

export const setSuggestions = (key, suggestions) => {
  return {
    type: SET_SUGGESTIONS,
    payload: {
      suggestions: {
        [key]: suggestions
      }
    }
  };
};

export const clearSuggestions = () => {
  return {
    type: CLEAR_SUGGESTIONS
  };
};

export default suggestions;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/suggestions/suggestions.js
 **/